import { AppState } from "@/models/TechnicianAppState";
import { UtilsDependencies } from "@/models/UtilsState";
import { STATE_MODULES } from '@/store/state-modules';
import { UTILS_DATA_STORAGE_KEY } from "@/store/modules/utils/actions";
import { UtilsMutations } from "@/store/modules/utils/mutations";
import { Store } from "vuex";
import { LoginMutations } from "@/store/modules/login/mutations";
import jwtService from "./jwt-service";

interface StorageUtilsData{
	value: Partial<UtilsDependencies>,
	expiry: number
}

export default {
	init: (store: Store<AppState>) => {
		store.commit(`${STATE_MODULES.LOGIN}/${LoginMutations.UPDATE_LOGIN_DETAILS}`, jwtService.jwt, { root: true });
		let utilsDataFromStorage: { [key: string]: any} | null = null;
		try {
			if (localStorage) {
				const data: StorageUtilsData | null = getStorageData();
				if (data) {
					if ((new Date()).getTime() > data.expiry) {
						localStorage.removeItem(UTILS_DATA_STORAGE_KEY);
					} else {
						utilsDataFromStorage = data.value;
					}
				}
			}
		} catch (error) {
			console.error(error);  // eslint-disable-line
		}

		if (utilsDataFromStorage) {
			store.commit(`${STATE_MODULES.UTILS}/${UtilsMutations.UPDATE_DEPENDENCIES}`, utilsDataFromStorage)
		}
	},
	setLocalStorageData: (utilsData: Partial<UtilsDependencies>) => {
		const storageData: StorageUtilsData | null = getStorageData();
		const newData: Partial<UtilsDependencies> = {
			...(storageData?.value || {}),
			...utilsData
		}

		const now = new Date();
		const item = {
			value: newData,
			expiry: storageData?.expiry || now.getTime() + 10 * 60 * 1000
		};
		
		localStorage.setItem(UTILS_DATA_STORAGE_KEY, JSON.stringify(item));
	}
}

function getStorageData (): StorageUtilsData | null {
	const storageData = localStorage.getItem(UTILS_DATA_STORAGE_KEY);
	if (storageData) {
		return JSON.parse(storageData);
	}

	return null;
}
